import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {Card} from 'material-ui/Card';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Header from './components/Header';
import Footer from './components/Footer'

export default class LandingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };

        this.logOutAction      = this.logOutAction.bind(this);
        this.content           = this.content.bind(this);
        this.additions         = this.additions.bind(this);
    }


    logOutAction () {
        this.setState({
        });
    }

    render() {
        const cardStyle = {};

        return (
            <Card style={cardStyle}>
            <Header onChange={this.changeLanguages()} />
            {this.content()}
            <Footer />
            </Card>);

    }

    content() {
          return this.additions();
    }

    additions() {
        return(
        <div>
            <Grid>

            </Grid>
        </div>);
    }

    changeLanguages(e) {
    }

}



// WEBPACK FOOTER //
// ./assets/src/js/LandingPage.jsx